<template>
  <div class="mailing-form position-relative">
    <form action="#">
      <div class="form-section">
        <label for="firstname">{{ form.firstName.label}}</label>
        <Input
            v-model="state.firstname"
            :warning="v$.firstname.$error"
            name="firstname"
            id="firstname"
            :placeholder="form.firstName.placeholder"
        />
        <span v-if="v$.firstname.$error" class="d-inline-block mt-1 text-secondary">{{ v$.firstname.$errors[0].$message }}</span>
      </div>
      <div class="form-section">
        <label for="lastname">{{ form.lastName.label}}</label>
        <Input
            v-model="state.lastname"
            :warning="v$.lastname.$error"
            name="lastname"
            id="lastname"
            :placeholder="form.lastName.placeholder"
        />
        <span v-if="v$.lastname.$error" class="d-inline-block mt-1 text-secondary">{{ v$.lastname.$errors[0].$message }}</span>
      </div>
      <div class="form-section">
        <label for="email">{{ form.email.label}}</label>
        <Input
            v-model="state.email"
            :warning="v$.email.$error"
            name="email" id="email"
            :placeholder="form.email.placeholder"
        />
        <span v-if="v$.email.$error" class="d-inline-block mt-1 text-secondary">{{ v$.email.$errors[0].$message }}</span>
      </div>
      <div class="form-section d-flex justify-content-end">
        <ButtonRed
            :loading="isLoading"
            :disabled="isLoading"
            :text="form.button.text"
            @click="submitForm"
        />
      </div>
    </form>
  </div>
</template>


<script>
import Input from "@/components/common/Input";
import ButtonRed from "@/components/common/ButtonRed";
import {email, minLength, required} from "@vuelidate/validators";
import useValidate from '@vuelidate/core'
import {computed, onBeforeMount, onMounted, reactive, watch} from "vue";
import useLoadData from "@/composables/useLoadData";
import {validations} from "@/utils/validators";
import {errors} from "@/config/messages";
import api from "@/config/api";
import {useReCaptcha} from "vue-recaptcha-v3";
import {getMailingFormRecaptcha} from "@/utils/utils";
import submitFormToGa from "@/utils/submitFormToGa";

export default {
  components: {ButtonRed, Input},
  props: {
    form: {
      formName: String,
      firstName: {
        placeholder: String,
        label: String
      },
      lastName: {
        placeholder: String,
        label: String
      },
      email: {
        placeholder: String,
        label: String
      },
      button: {
        text: String
      },
      errors: {
        empty: String,
        email: String,
        containLetters: String,
        onlyNumbers: String
      }
    },
    clearForm: Boolean,
  },
  setup(props, context){
    const { data: formSubmitResponse, fetchData: sendForm, isLoading } = useLoadData()
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
    const formName = props.form.formName
    const state = reactive({
      firstname: '',
      lastname: '',
      email: '',
    })

    let rules = computed(() => {
      return {
        firstname: {
          required: validations.base.required(window['form-errors']?.empty || errors.empty),
          minLength: minLength(2)
        },
        lastname: {
          required: validations.base.required(window['form-errors']?.empty || errors.empty),
          minLength: minLength(2)
        },
        email: {
          required: validations.base.required(window['form-errors']?.empty || errors.empty),
          email: validations.email.email(window['form-errors']?.email || errors.email)
        },
      }
    });

    const recaptcha = async () => {
      isLoading.value = true;
      const data = { ...getMailingFormRecaptcha(state, formName)}

      // (optional) Wait until recaptcha has been loaded.
      await recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await executeRecaptcha('login')

      await sendForm({
        url: api.formSubmit,
        method: 'post',
        data: {
          ...data,
          recaptchaToken: token
        }
      })

      submitFormToGa(formName);

      formSubmitResponse.value.returnUrl !== null && formSubmitResponse.value.returnUrl.length > 0 ?
          this.$router.go(formSubmitResponse.value.returnUrl)
          : context.emit('submit')
    }

    const v$ = useValidate(rules, state)

    return {
      state,
      v$,
      recaptcha,
      isLoading
    }
  },
  methods: {
    async submitForm(){
      await this.v$.$validate()

      if(!this.v$.$error && !this.isLoading) {
        this.recaptcha();
      }
    },
  },
  watch: {
    clearForm: {
      handler() {
        this.v$.firstname.$reset()
        this.v$.lastname.$reset()
        this.v$.email.$reset()

        this.state.firstname = ''
        this.state.lastname = ''
        this.state.email = ''
      }
    }
  },
}
</script>
